import { Component } from "react"
import PropTypes from "prop-types"

import "./selected_service.scss"

export default class SelectedService extends Component {
  onServiceDeselect = () => {
    this.props.onServiceDeselect(this.props.service)
  }

  render() {
    const service = this.props.service
    return (
      <div className="input new-connect-ui" styleName="with-close-option">
        <input type="text" value={service.name} disabled />
        <div
          styleName="dropdown-service-tile"
          style={{
            backgroundColor: `#${service.brand_color}`,
          }}
        >
          <img
            src={service.lrg_monochrome_image_url}
            alt={service.name}
            title={service.name}
          />
        </div>
        <div
          styleName="close-btn"
          className="close-btn"
          onClick={this.onServiceDeselect}
          title="Click to select another service"
          aria-label="Click to select another service"
        ></div>
      </div>
    )
  }
}

SelectedService.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.string,
    module_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onServiceDeselect: PropTypes.func.isRequired,
}
